import React from "react";
import { Link } from "react-router-dom";
import LazyLoadIframe from './LazyLoadIframe';
const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <div className="row">
            <div className="col-md-3 col-12">
              <div className="footer-tp-left">
                <img
                  src={`${BASEURL}/images/logo.svg`}
                  width="215"
                  height="81"
                  alt="footer logo"
                />
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="footer-tp-midle">
                <h5>Building Real Property Solutions</h5>
                <div className="text-center">
                  <a
                    href="https://www.linkedin.com/company/somerset-properties"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22.361"
                      height="22.361"
                      viewBox="0 0 22.361 22.361"
                    >
                      <path
                        id="icons8-linkedin"
                        d="M23.7,4H6.662A2.663,2.663,0,0,0,4,6.662V23.7a2.663,2.663,0,0,0,2.662,2.662H23.7A2.663,2.663,0,0,0,26.361,23.7V6.662A2.663,2.663,0,0,0,23.7,4ZM10.921,12.518V22.634H7.727V12.518ZM7.727,9.574a1.419,1.419,0,0,1,1.6-1.315,1.44,1.44,0,0,1,1.6,1.315,1.417,1.417,0,0,1-1.6,1.347A1.441,1.441,0,0,1,7.727,9.574Zm14.907,13.06H19.439V17.31a1.914,1.914,0,0,0-1.863-2.151h-.043c-1.288,0-1.821,1.1-1.821,2.151v5.324H12.518V12.518h3.194v1.363a3.988,3.988,0,0,1,3.093-1.363c2.114,0,3.828,1.453,3.828,4.4Z"
                        transform="translate(-4 -4)"
                        fill="#9fa4a2"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-12">
              <div className="footer-tp-right">
                <h5 id="footer_mobile">
                  <a href="tel:2674605658">2674605658</a>
                </h5>
                <p id="footer_address">
                  275 Commerce Drive Suite 300 Ft. Washington, Pennsylvania
                  19034
                </p>
                <div className="footer-map">
                <LazyLoadIframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3050.271355794203!2d-75.20316342414684!3d40.13623887148607!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6bae29a182e5b%3A0xc2da640bdd501916!2s275%20Commerce%20Dr%20%23300%2C%20Fort%20Washington%2C%20PA%2019034%2C%20USA!5e0!3m2!1sen!2sin!4v1709193602951!5m2!1sen!2sin"
                width="100%"
                height="250"
                title="Google Map"
              />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <ul>
            <li>
              <Link to="">Acquisitions</Link>
            </li>
            <li>
              <Link to="">Development</Link>
            </li>
            <li>
              <Link to="">Property Management</Link>
            </li>
            <li>
              <Link to="">Leasing</Link>
            </li>
            <li>
              <Link to="">Investing</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
